export default __webpack_public_path__ + "static/media/5Klein.662bb432.jpg";